// src/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ isUserValidated, children }) {
  if (!isUserValidated) {
    // Redirect to login if user is not validated
    return <Navigate to='/' replace />;
  }

  // Render the requested route if validated
  return children;
}

export default ProtectedRoute;
